var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 3.33337C10.4601 3.33337 10.8332 3.70647 10.8332 4.16671V15.8334C10.8332 16.2936 10.4601 16.6667 9.99984 16.6667C9.5396 16.6667 9.1665 16.2936 9.1665 15.8334V4.16671C9.1665 3.70647 9.5396 3.33337 9.99984 3.33337Z",
    fill: "#1E293B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41058 10.2441C4.73602 9.91868 5.26366 9.91868 5.58909 10.2441L9.99984 14.6549L14.4106 10.2441C14.736 9.91868 15.2637 9.91868 15.5891 10.2441C15.9145 10.5696 15.9145 11.0972 15.5891 11.4226L10.5891 16.4226C10.2637 16.7481 9.73602 16.7481 9.41058 16.4226L4.41058 11.4226C4.08514 11.0972 4.08514 10.5696 4.41058 10.2441Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetPaid);
export default __webpack_public_path__ + "static/media/getPaid.fa9a4d52609605e1d40b56f69dffe601.svg";
export { ForwardRef as ReactComponent };